import { render, staticRenderFns } from "./IconDripicons.vue?vue&type=template&id=36944cd0&"
import script from "./IconDripicons.vue?vue&type=script&lang=js&"
export * from "./IconDripicons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports